var content = require("!!../../../../react/node_modules/css-modules-typescript-loader/index.js!../../../../react/node_modules/css-loader/dist/cjs.js??ref--6-2!../../../../react/node_modules/postcss-loader/src/index.js??ref--6-3!../../../../react/node_modules/sass-loader/dist/cjs.js??ref--6-4!./card.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../react/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
